import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'

import { REMOVE_ENVELOPE_QUERY_KEYS, removeEnvelope } from './remove-envelope'

export const useRemoveEnvelope = (feedback?: MutationFeedback) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (envelopeId: string) => removeEnvelope(envelopeId),
    onSettled: () => {
      for (const queryKey of REMOVE_ENVELOPE_QUERY_KEYS) {
        void queryClient.invalidateQueries({ queryKey: [queryKey] })
      }
    },
    meta: {
      ...feedback,
    },
  })
}
